const BOSS_PROFILE_IMAGE = '/profile/sonu-boss.png?v=2'

export const SOCIAL_PROFILES = [
  {
    id: 'github',
    name: 'GitHub',
    username: 'sonu_saarkaar',
    headline: 'Code, repositories, and open-source work.',
    profileUrl: 'https://github.com/sonu_saarkaar',
    handle: '@sonu_saarkaar',
    avatarUrl: BOSS_PROFILE_IMAGE,
    theme: {
      gradient: 'linear-gradient(135deg, #0d1117 0%, #161b22 50%, #30363d 100%)',
      accent: '#2ea043',
      soft: 'rgba(46, 160, 67, 0.2)'
    },
    stats: [
      { label: 'Platform', value: 'Developer Network' },
      { label: 'Identity', value: 'Open Source Builder' },
      { label: 'Profile', value: 'Public' }
    ],
    details: [
      'Repository showcase and contribution activity.',
      'Code-first profile themed for technical credibility.',
      'Best for collaboration and project deep dives.'
    ]
  },
  {
    id: 'x',
    name: 'X (Twitter)',
    username: 'sonu_saarkaar',
    headline: 'Short-form thoughts, updates, and announcements.',
    profileUrl: 'https://x.com/sonu_saarkaar',
    handle: '@sonu_saarkaar',
    avatarUrl: BOSS_PROFILE_IMAGE,
    theme: {
      gradient: 'linear-gradient(135deg, #000000 0%, #111111 50%, #1d1d1d 100%)',
      accent: '#1d9bf0',
      soft: 'rgba(29, 155, 240, 0.2)'
    },
    stats: [
      { label: 'Platform', value: 'Microblog' },
      { label: 'Content', value: 'Tech + Vision' },
      { label: 'Status', value: 'Active Profile' }
    ],
    details: [
      'Fast updates around product, ideas, and execution.',
      'Conversation-centric design inspired by X timeline style.',
      'Ideal for quick public communication.'
    ]
  },
  {
    id: 'threads',
    name: 'Threads',
    username: 'sonu_saarkaar',
    headline: 'Community conversations and creator discussions.',
    profileUrl: 'https://www.threads.net/@sonu_saarkaar',
    handle: '@sonu_saarkaar',
    avatarUrl: BOSS_PROFILE_IMAGE,
    theme: {
      gradient: 'linear-gradient(135deg, #101010 0%, #1a1a1a 50%, #272727 100%)',
      accent: '#ffffff',
      soft: 'rgba(255, 255, 255, 0.18)'
    },
    stats: [
      { label: 'Platform', value: 'Conversation Feed' },
      { label: 'Style', value: 'Community-first' },
      { label: 'Status', value: 'Profile Ready' }
    ],
    details: [
      'Text-first social narrative with visual identity consistency.',
      'Mapped profile structure with username parity.',
      'Built for audience engagement and discussions.'
    ]
  },
  {
    id: 'instagram',
    name: 'Instagram',
    username: 'sonu_saarkaar',
    headline: 'Visual highlights, reels, and creative snapshots.',
    profileUrl: 'https://instagram.com/sonu_saarkaar',
    handle: '@sonu_saarkaar',
    avatarUrl: BOSS_PROFILE_IMAGE,
    theme: {
      gradient: 'linear-gradient(135deg, #833ab4 0%, #fd1d1d 52%, #fcb045 100%)',
      accent: '#ffd166',
      soft: 'rgba(252, 176, 69, 0.25)'
    },
    stats: [
      { label: 'Platform', value: 'Visual Social' },
      { label: 'Content', value: 'Images + Reels' },
      { label: 'Identity', value: 'Creator Profile' }
    ],
    details: [
      'Reel and visual showcase style cards.',
      'Profile header inspired by Instagram layout language.',
      'Strong branding alignment for portfolio storytelling.'
    ]
  },
  {
    id: 'facebook',
    name: 'Facebook',
    username: 'sonu_saarkaar',
    headline: 'Network presence, profile highlights, and updates.',
    profileUrl: 'https://facebook.com/sonu_saarkaar',
    handle: '@sonu_saarkaar',
    avatarUrl: BOSS_PROFILE_IMAGE,
    theme: {
      gradient: 'linear-gradient(135deg, #1877f2 0%, #0f58b8 60%, #0b3d80 100%)',
      accent: '#dce8ff',
      soft: 'rgba(220, 232, 255, 0.25)'
    },
    stats: [
      { label: 'Platform', value: 'Social Network' },
      { label: 'Content', value: 'Posts + Community' },
      { label: 'Status', value: 'Public Identity' }
    ],
    details: [
      'Classic social profile framing with clean cards.',
      'Community and update-centric information blocks.',
      'Easy access for broader audience reach.'
    ]
  },
  {
    id: 'whatsapp',
    name: 'WhatsApp',
    username: 'sonu_saarkaar',
    headline: 'Direct conversation channel for collaboration.',
    profileUrl: 'https://wa.me/919798299944',
    handle: '+91 9798299944',
    avatarUrl: BOSS_PROFILE_IMAGE,
    theme: {
      gradient: 'linear-gradient(135deg, #075e54 0%, #128c7e 52%, #25d366 100%)',
      accent: '#dcffe8',
      soft: 'rgba(220, 255, 232, 0.25)'
    },
    stats: [
      { label: 'Platform', value: 'Direct Messaging' },
      { label: 'Contact', value: '+91 9798299944' },
      { label: 'Availability', value: 'Business Connect' }
    ],
    details: [
      'Instant communication entry point.',
      'Optimized for quick collaboration and project discussions.',
      'One-click chat opening with preconfigured identity.'
    ]
  },
  {
    id: 'leetcode',
    name: 'LeetCode',
    username: 'sonu_saarkaar',
    headline: 'Problem-solving profile and coding practice footprint.',
    profileUrl: 'https://leetcode.com/sonu_saarkaar',
    handle: 'leetcode.com/sonu_saarkaar',
    avatarUrl: BOSS_PROFILE_IMAGE,
    theme: {
      gradient: 'linear-gradient(135deg, #1a1a1a 0%, #222831 52%, #f89f1b 100%)',
      accent: '#ffd29d',
      soft: 'rgba(248, 159, 27, 0.22)'
    },
    stats: [
      { label: 'Platform', value: 'Coding Challenges' },
      { label: 'Focus', value: 'DSA + Logic' },
      { label: 'Type', value: 'Skill Profile' }
    ],
    details: [
      'Structured profile view aligned with coding culture aesthetics.',
      'Practice-oriented social signal for recruiters and peers.',
      'Complements GitHub with algorithmic depth.'
    ]
  },
  {
    id: 'website',
    name: 'Website',
    username: 'sonu_saarkaar',
    headline: 'Official SAARKAAR web presence and portfolio gateway.',
    profileUrl: 'https://saarkaar.in',
    handle: 'saarkaar.in',
    avatarUrl: BOSS_PROFILE_IMAGE,
    theme: {
      gradient: 'linear-gradient(135deg, #070b15 0%, #0d1d3b 55%, #193d74 100%)',
      accent: '#8fd3ff',
      soft: 'rgba(143, 211, 255, 0.2)'
    },
    stats: [
      { label: 'Domain', value: 'saarkaar.in' },
      { label: 'Role', value: 'Primary Identity' },
      { label: 'Content', value: 'Portfolio + Products' }
    ],
    details: [
      'Main platform for official work and offerings.',
      'Entry point to products, projects, and contact channels.',
      'Matches brand tone with futuristic visual language.'
    ]
  },
  {
    id: 'gmail',
    name: 'Gmail',
    username: 'sonu_saarkaar',
    headline: 'Professional email communication channel.',
    profileUrl: 'mailto:sonusaarkaar@gmail.com',
    handle: 'sonusaarkaar@gmail.com',
    avatarUrl: BOSS_PROFILE_IMAGE,
    theme: {
      gradient: 'linear-gradient(135deg, #ea4335 0%, #fbbc05 35%, #34a853 70%, #4285f4 100%)',
      accent: '#fff3df',
      soft: 'rgba(255, 243, 223, 0.25)'
    },
    stats: [
      { label: 'Email', value: 'sonusaarkaar@gmail.com' },
      { label: 'Type', value: 'Professional Inbox' },
      { label: 'Use', value: 'Business / Projects' }
    ],
    details: [
      'Direct professional reach-out path.',
      'Ideal for proposal, hiring, and collaboration messages.',
      'One-click email compose support from profile page.'
    ]
  },
  {
    id: 'phone',
    name: 'Contact Number',
    username: 'sonu_saarkaar',
    headline: 'Primary business contact for direct calls.',
    profileUrl: 'tel:+919798299944',
    handle: '+91 9798299944',
    avatarUrl: BOSS_PROFILE_IMAGE,
    theme: {
      gradient: 'linear-gradient(135deg, #0f172a 0%, #1e293b 52%, #334155 100%)',
      accent: '#cbd5e1',
      soft: 'rgba(203, 213, 225, 0.2)'
    },
    stats: [
      { label: 'Phone', value: '+91 9798299944' },
      { label: 'Usage', value: 'Business Calls' },
      { label: 'Region', value: 'India (+91)' }
    ],
    details: [
      'Fastest channel for urgent discussions.',
      'Suitable for project calls and business coordination.',
      'Integrated dial action for direct reach.'
    ]
  }
]

export const SOCIAL_BY_ID = SOCIAL_PROFILES.reduce((acc, item) => {
  acc[item.id] = item
  return acc
}, {})
